(function () {
  // ===== SETTINGS =====
  const CALC_BTN_SELECTOR = '.addToCartCustomButton';
  const HIDE_STYLE_ID = 'hide-app-drawer-style';
  const DEPOSIT_VARIANT_ID = 62376119894385;
  const SELECTOR_TOTAL = '.addition-price-value';
  let CLICK_LOCK = false;

  // ===== small helpers =====
  function parseMoney(txt) {
    if (!txt) return null;
    let s = txt.replace(/\u00A0/g, ' ').replace(/[^0-9,.\- ]/g, '').trim();
    s = s.replace(/(\d)[,](\d{2})$/, '$1.$2');
    s = s.replace(/ /g, '').replace(/,(?=\d{3}\b)/g, '');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : null;
  }

  // прячем попап приложения навсегда
  function hideCalcPopupPermanently() {
    if (document.getElementById(HIDE_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = HIDE_STYLE_ID;
    style.textContent = `
      .custom-cart-view, .custom-cart-view *{
        display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;
      }`;
    document.head.appendChild(style);
    const mo = new MutationObserver(list => {
      for (const m of list) {
        const el = m.target;
        if (el instanceof HTMLElement && el.classList?.contains('custom-cart-view')) {
          el.style.display = 'none'; el.style.visibility = 'hidden'; el.style.pointerEvents = 'none';
        }
      }
    });
    mo.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['style','class'] });
  }
  hideCalcPopupPermanently();

  // автоочистка корзины после перезагрузки/back
  async function clearCart() {
    try {
      await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } });
    } catch (e) { console.warn('[addr-popup] cart clear failed', e); }
  }
  (function setupSimpleAutoclear(){
    window.addEventListener('pageshow', () => {
      if (sessionStorage.getItem('addr_clear_on_load') === '1') {
        clearCart().catch(()=>{});
        sessionStorage.removeItem('addr_clear_on_load');
      }
    }, { once:true });
  })();

  // собрать загруженные файлы (до 5)
  function getDesignFiles(max = 5) {
    const out = [];
    document.querySelectorAll(
      '.option-multifileupload-input, input[type="file"].opc-file-input, .opc-file input[type="file"], input[type="file"][name*="upload"], input[type="file"][multiple]'
    ).forEach(inp => {
      Array.from(inp.files || []).forEach(f => { if (out.length < max) out.push(f); });
    });
    return out;
  }

  // ===== OPC → props =====
  function collectOPCMin(limit = 10) {
    const props = {}; let count = 0;
    document.querySelectorAll('.optionHolder').forEach(hold => {
      if (count >= limit) return;
      let label = (hold.querySelector('.option-label')?.textContent || '')
        .replace(/\s*\*+$/, '').replace(/\s*:\s*$/, '').trim();
      if (!label) return;

      if (/^number of units per design$/i.test(label)) {
        const qtyEl = hold.querySelector('.opc-quantity-holder .opc-quantity') || hold.querySelector('input[id^="quantity-"]');
        let q = (qtyEl?.value || qtyEl?.getAttribute?.('value') || '').replace(/[^\d]/g, '');
        if (q) { const k = label.slice(0,60); if (!(k in props)) { props[k] = q; count++; } }
        return;
      }

      let value =
        hold.querySelector('.opc-selected-name')?.textContent?.trim() ||
        hold.querySelector('.selected-dropdown-view .dropdown-label, .tab-view.selected .dropdown-label')?.textContent?.trim() ||
        hold.querySelector('select')?.selectedOptions?.[0]?.text?.trim() ||
        hold.querySelector('input[type="text"], textarea')?.value?.trim() || '';

      if (value && /^\d[\d\s.,]*$/.test(value)) value = value.replace(/[^\d.]/g, '');
      value = (value || '').trim();

      const looksLikeInternalId = /^[0-9a-f-]{20,}$/i.test(value);
      const placeholder = /^(select|choose|not selected|none)$/i.test(value);
      if (!value || placeholder || looksLikeInternalId) {
        if (/custom|customization|glass/i.test(label)) {
          const k = label.slice(0,60); if (!(k in props)) { props[k] = 'none'; count++; }
        }
        return;
      }

      const key = label.slice(0, 60);
      if (!(key in props)) { props[key] = value.slice(0, 100); count++; }
    });

    // размеры из видимого блока "Dimensions"
    (function() {
      const block = document.querySelector('.option-list-frame.option-name-display');
      if (!block) return;
      const lbl = (block.querySelector('.option-label')?.textContent || '').trim();
      if (!/dimensions/i.test(lbl)) return;
      const txt = (block.querySelector('.opc-selected-name')?.textContent || '').trim();
      if (!txt) return;
      const nums = (txt.match(/\d+(?:[.,]\d+)?/g) || []).map(s => s.replace(',', '.'));
      const unit = (txt.match(/\b(mm|cm|in|mil)\b/i) || [,''])[1] || (/\bmm\b/i.test(txt) ? 'mm' : '');
      const put = (k,v)=>{ if (!v) return; if (!(k in props)) props[k] = unit ? `${v}${unit}` : v; };
      put('Width', nums[0]); put('Height', nums[1]); put('Gusset', nums[2]);
      if (!('Dimensions' in props)) props['Dimensions'] = txt;
    })();

    return props;
  }

  function buildNiceSummary(props = {}, files = []) {
    const W = props['Width'] || props['Width (mm)'] || props['Ширина'] || props['Bag Width'] || '';
    const H = props['Height'] || props['Height (mm)'] || props['Высота'] || props['Bag Height'] || '';
    const G = props['Gusset'] || props['Gusset (mm)'] || props['Дно/Боковина'] || '';
    const lines = [];
    if (W || H || G) {
      const parts = []; if (W) parts.push(`Width: ${W}`); if (H) parts.push(`Height: ${H}`); if (G) parts.push(`Gusset: ${G}`);
      lines.push(`Dimensions: ${parts.join(' | ')}`);
    }
    const unitsVal = props['Number of Units per Design'] || props['Units per Design'] || props['Units'];
    if (unitsVal) lines.push(`Units per Design: ${unitsVal}`);
    if (props['Material'])      lines.push(`Material: ${props['Material']}`);
    if (props['Finishing'])     lines.push(`Finishing: ${props['Finishing']}`);
    if (props['Customization']) lines.push(`Customization: ${props['Customization']}`);
    const designsFromProps = props['Number of Designs'] || props['Designs count'];
    if (designsFromProps) lines.push(`Number of Designs: ${designsFromProps}`);
    if (files && files.length) {
      const names = files.map(f => f?.name).filter(Boolean);
      if (names.length) lines.push(`(optional) Upload your Designs: ${names.join(', ')}`);
    }
    return lines.join('\n');
  }

  function getQuoteData() {
    const el = document.querySelector(SELECTOR_TOTAL);
    const raw = el && (el.textContent || el.innerText);
    const total = parseMoney(raw);
    const props = collectOPCMin(10);
    const files = getDesignFiles();
    const summaryText = buildNiceSummary(props, files);
    return { total, summaryText, files };
  }

  // ===== UI bits =====
  function injectCSS() {
    if (document.getElementById('addr-popup-css')) return;
    const s = document.createElement('style');
    s.id = 'addr-popup-css';
    s.textContent = `
  .addr-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:999999;display:none;opacity:0;transition:opacity .2s;}
  .addr-wrap{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1000000;pointer-events:none;}
  .addr-modal{width:min(760px,94vw);max-height:88vh;background:#fff;border-radius:12px;box-shadow:0 20px 50px rgba(0,0,0,.25);overflow:auto;pointer-events:auto;}
  .addr-head{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #eee;font-weight:600}
  .addr-body{display:grid;grid-template-columns:1fr 1fr;gap:12px;padding:14px 16px}
  .addr-field{display:flex;flex-direction:column;gap:6px}
  .addr-field input,.addr-field select{border:1px solid #ddd;border-radius:8px;padding:10px 12px;font-size:14px}
  .addr-rates{grid-column:1/-1;display:flex;flex-direction:column;gap:8px}
  .label-addr-rate{display:flex;justify-content:space-between;align-items:center;border:1px solid #eee;border-radius:10px;padding:10px 12px;cursor:pointer;gap:10px}
  .label-addr-rate.is-selected{border-color:#111;box-shadow:0 0 0 2px rgba(0,0,0,.06) inset}
  .addr-transit{font-size:12px;color:#666;margin-left:6px}
  .addr-alert{grid-column:1/-1;background:#fff4f4;border:1px solid #f5c2c2;color:#842029;border-radius:8px;padding:10px 12px;font-size:13px}
  .addr-field-error{font-size:12px;color:#c0392b;margin-top:4px}
  .addr-invalid{border-color:#e74c3c!important;box-shadow:0 0 0 2px rgba(231,76,60,.15)}
  .addr-pre{grid-column:1/-1;white-space:pre-wrap;font-family:ui-monospace,Menlo,Consolas,monospace;font-size:12px;background:#fafafa;border:1px solid #eee;border-radius:8px;padding:10px}
  .addr-btn{border:1px solid #ddd;background:#fff;border-radius:10px;padding:10px 14px;font-weight:600;cursor:pointer;font-size:16px}
  .addr-btn--primary{background:#111;color:#fff;border-color:#111}
  .addr-loader{display:none;margin-left:8px;border:2px solid #eee;border-left-color:#111;border-radius:50%;width:16px;height:16px;animation:addr-spin .75s linear infinite}

  @keyframes addr-spin { to { transform: rotate(360deg); } }
  @media (max-width: 500px) {
    .addr-body { grid-template-columns: 1fr; }
    .label-addr-rate { flex-direction: column; align-items: flex-start; gap:6px; }
    .addr-foot { flex-direction: column; align-items: stretch; gap:8px; }
    .addr-btn { font-size: 12px }
  }
`;

    document.head.appendChild(s);
  }

  const US_STATES = [
    {code:'AL',name:'Alabama'},{code:'AK',name:'Alaska'},{code:'AZ',name:'Arizona'},{code:'AR',name:'Arkansas'},
    {code:'CA',name:'California'},{code:'CO',name:'Colorado'},{code:'CT',name:'Connecticut'},{code:'DE',name:'Delaware'},
    {code:'FL',name:'Florida'},{code:'GA',name:'Georgia'},{code:'HI',name:'Hawaii'},{code:'ID',name:'Idaho'},
    {code:'IL',name:'Illinois'},{code:'IN',name:'Indiana'},{code:'IA',name:'Iowa'},{code:'KS',name:'Kansas'},
    {code:'KY',name:'Kentucky'},{code:'LA',name:'Louisiana'},{code:'ME',name:'Maine'},{code:'MD',name:'Maryland'},
    {code:'MA',name:'Massachusetts'},{code:'MI',name:'Michigan'},{code:'MN',name:'Minnesota'},{code:'MS',name:'Mississippi'},
    {code:'MO',name:'Missouri'},{code:'MT',name:'Montana'},{code:'NE',name:'Nebraska'},{code:'NV',name:'Nevada'},
    {code:'NH',name:'New Hampshire'},{code:'NJ',name:'New Jersey'},{code:'NM',name:'New Mexico'},{code:'NY',name:'New York'},
    {code:'NC',name:'North Carolina'},{code:'ND',name:'North Dakota'},{code:'OH',name:'Ohio'},{code:'OK',name:'Oklahoma'},
    {code:'OR',name:'Oregon'},{code:'PA',name:'Pennsylvania'},{code:'RI',name:'Rhode Island'},{code:'SC',name:'South Carolina'},
    {code:'SD',name:'South Dakota'},{code:'TN',name:'Tennessee'},{code:'TX',name:'Texas'},{code:'UT',name:'Utah'},
    {code:'VT',name:'Vermont'},{code:'VA',name:'Virginia'},{code:'WA',name:'Washington'},{code:'WV',name:'West Virginia'},
    {code:'WI',name:'Wisconsin'},{code:'WY',name:'Wyoming'},{code:'DC',name:'District of Columbia'},{code:'PR',name:'Puerto Rico'}
  ];
  const AE_EMIRATES = [
    {code:'Abu Dhabi',name:'Abu Dhabi'},{code:'Dubai',name:'Dubai'},{code:'Sharjah',name:'Sharjah'},
    {code:'Ajman',name:'Ajman'},{code:'Umm Al Quwain',name:'Umm Al Quwain'},{code:'Ras Al Khaimah',name:'Ras Al Khaimah'},
    {code:'Fujairah',name:'Fujairah'},
  ];
  function fillSelect(sel, items, placeholder='Select…'){
    sel.innerHTML = `<option value="">${placeholder}</option>` + items.map(it => `<option value="${it.name}">${it.name}</option>`).join('');
  }
  function updateProvinceControl(){
    const country = document.getElementById('addr-country')?.value;
    const sel = document.getElementById('addr-state');
    const inp = document.getElementById('addr-province');
    if (!sel || !inp) return;
    if (country === 'United States'){ fillSelect(sel, US_STATES, 'Select state'); sel.style.display=''; inp.style.display='none'; }
    else if (country === 'United Arab Emirates'){ fillSelect(sel, AE_EMIRATES, 'Select emirate'); sel.style.display=''; inp.style.display='none'; }
    else { sel.style.display='none'; inp.style.display=''; }
  }
  function applyCountryUi(){
    updateProvinceControl();
    const country = document.getElementById('addr-country')?.value;
    const city = document.getElementById('addr-city');
    const zip  = document.getElementById('addr-zip');
    const addr1= document.getElementById('addr-address');
    const provInp = document.getElementById('addr-province');
    const stateSel= document.getElementById('addr-state');
    const zipLabel  = zip?.closest('.addr-field')?.querySelector('label');
    const provLabel = provInp?.closest('.addr-field')?.querySelector('label');

    if (country === 'United States'){
      if (zipLabel)  zipLabel.textContent  = 'ZIP code';
      if (provLabel) provLabel.textContent = 'State';
      (stateSel?.style.display !== 'none' ? stateSel.querySelector('option[value=""]') : provInp).placeholder = 'State';
      zip.placeholder = 'ZIP code'; city.placeholder='City'; addr1.placeholder='Street address, apt/suite';
    } else if (country === 'United Arab Emirates'){
      if (zipLabel)  zipLabel.textContent  = 'Postal code';
      if (provLabel) provLabel.textContent = 'Emirate';
      (stateSel?.style.display !== 'none' ? stateSel.querySelector('option[value=""]') : provInp).textContent = 'Select emirate';
      provInp.placeholder='Emirate'; zip.placeholder='Postal code (if any)'; city.placeholder='City'; addr1.placeholder='Street address, building, flat';
    } else {
      if (zipLabel)  zipLabel.textContent  = 'Postal code';
      if (provLabel) provLabel.textContent = 'State / Province';
      provInp.placeholder='State / Province'; zip.placeholder='Postal code'; city.placeholder='City / Town'; addr1.placeholder='Street address, apt/suite';
    }
  }

  function clearErrors(){
    const box = document.getElementById('addr-errors'); if (box){ box.style.display='none'; box.innerHTML=''; }
    document.querySelectorAll('.addr-field-error').forEach(n=>n.remove());
    ['addr-country','addr-province','addr-state','addr-city','addr-zip','addr-address'].forEach(id=>{
      document.getElementById(id)?.classList.remove('addr-invalid');
    });
  }
  function setFieldError(id, msg){
    const el = document.getElementById(id); if (!el) return;
    el.classList.add('addr-invalid');
    const holder = el.closest('.addr-field');
    if (holder){ const n = document.createElement('div'); n.className='addr-field-error'; n.textContent=msg; holder.appendChild(n); }
  }
  function showTopError(msgs){
    const box = document.getElementById('addr-errors'); if (!box) return;
    box.innerHTML = '<strong>We couldn’t calculate shipping:</strong>' +
      '<ul style="margin:6px 0 0 18px">' + msgs.map(m=>`<li>${m}</li>`).join('') + '</ul>';
    box.style.display = 'block';
  }

  // popup
  function ensurePopup(){
    if (document.getElementById('addr-popup')) return;
    injectCSS();
    const overlay = document.createElement('div'); overlay.id='addr-overlay'; overlay.className='addr-overlay';
    const wrap = document.createElement('div'); wrap.id='addr-wrap'; wrap.className='addr-wrap'; wrap.style.display='none';
    const modal = document.createElement('div'); modal.id='addr-popup'; modal.className='addr-modal'; modal.innerHTML = `
      <div class="addr-head"><div>Shipping</div><button class="addr-btn" data-addr-close>&times;</button></div>
      <div class="addr-body">
        <div class="addr-field"><label>Country</label>
          <select id="addr-country"><option value="United States">United States</option><option value="United Arab Emirates">United Arab Emirates</option></select>
        </div>
        <div class="addr-field"><label>State / Province</label><input id="addr-province" autocomplete="off" placeholder="State / Province"></div>
        <div class="addr-field"><label>City</label><input id="addr-city" autocomplete="off" autocomplete="off" placeholder="City"></div>
        <div class="addr-field"><label>ZIP / Postal</label><input id="addr-zip" autocomplete="off" placeholder="ZIP / Postal"></div>
        <div class="addr-field"><label>Address</label><input id="addr-address" autocomplete="off" placeholder="Street address, apt/suite"></div>
        <div id="addr-errors" class="addr-alert" style="display:none"></div>
        <div class="addr-rates">
          <div style="display:flex;align-items:center;gap:8px;">
            <strong id="addr-status"></strong>
            <span id="addr-spinner" class="addr-loader"></span>
          </div>
          <div id="addr-rates-list"></div>
        </div>
      </div>
      <div class="addr-foot">
        <div></div>
        <div style="display:flex;gap:10px; padding: 14px 16px">
          <button class="addr-btn" id="addr-calc">Calculate shipping</button>
          <a id="addr-checkout" class="addr-btn addr-btn--primary" href="/checkout" style="display:none">Review order</a>
        </div>
      </div>`;
    wrap.appendChild(modal);

    // селект для штатов/эмиратов
    const provInput = modal.querySelector('#addr-province');
    if (provInput) {
      const stateSelect = document.createElement('select'); stateSelect.id='addr-state'; stateSelect.style.display='none';
      provInput.insertAdjacentElement('afterend', stateSelect);
    }

    document.body.appendChild(overlay); document.body.appendChild(wrap);

    const close = async () => {
      wrap.style.display = 'none'; overlay.style.opacity = '0'; setTimeout(()=>{ overlay.style.display='none'; }, 200);
      CLICK_LOCK = false; await clearCart(); sessionStorage.removeItem('addr_clear_on_load');
    };
    overlay.addEventListener('click', close);
    wrap.querySelectorAll('[data-addr-close]').forEach(b => b.addEventListener('click', close));

    // Add deposit
    const checkoutBtn = document.getElementById('addr-checkout');
    checkoutBtn.addEventListener('click', async (e) => {
      e.preventDefault(); checkoutBtn.disabled = true;
      const original = checkoutBtn.textContent;          // <-- добавить
      try { await addDepositWithDetails(); sessionStorage.removeItem('addr_clear_on_load'); window.location.href = '/checkout'; }
      catch(e){ console.error('[deposit] error', e); alert('Could not add deposit. Please try again.'); }
      finally { checkoutBtn.textContent = original; checkoutBtn.disabled = false; }
    });


    // реакция на смену страны
    document.getElementById('addr-country')?.addEventListener('change', applyCountryUi);

    // открыть попап
    window.__addr_open = () => {
      sessionStorage.setItem('addr_clear_on_load', '1');
      try {
        const props = collectOPCMin(10);
        const summary = buildNiceSummary(props, []);
        const pre = document.getElementById('addr-quote');
        if (pre) pre.textContent = summary || '(no data)';
      } catch(_) {}
      overlay.style.display='block'; requestAnimationFrame(()=>{ overlay.style.opacity='1'; });
      wrap.style.display='flex'; applyCountryUi();
    };
  }

  function normalizeAddress(){
    const sel = document.getElementById('addr-state');
    const inp = document.getElementById('addr-province');
    const useSelect = sel && sel.style.display !== 'none' && sel.value;
    return {
      country:  document.getElementById('addr-country').value.trim(),
      province: useSelect ? sel.value.trim() : (inp?.value.trim() || ''),
      city:     document.getElementById('addr-city').value.trim(),
      zip:      document.getElementById('addr-zip').value.trim(),
      address1: document.getElementById('addr-address')?.value.trim() || ''
    };
  }

  async function fetchRates(addr){
    const p = new URLSearchParams();
    if (addr.country)  p.set('shipping_address[country]', addr.country);
    if (addr.province) p.set('shipping_address[province]', addr.province);
    if (addr.city)     p.set('shipping_address[city]', addr.city);
    if (addr.zip)      p.set('shipping_address[zip]', addr.zip);
    if (addr.address1) p.set('shipping_address[address1]', addr.address1);

    const res = await fetch(`/cart/shipping_rates.json?${p.toString()}`, { credentials:'same-origin', headers:{'Accept':'application/json'} });
    if (!res.ok){ throw new Error(`rates ${res.status}: ` + (await res.text())); }
    const json = await res.json(); return json.shipping_rates || [];
  }

  const getRateTitle = r => (r.presentment_name || r.name || '').trim();
  function extractTransitDays(r){
    const now = new Date(); const toDays = (d)=>Math.max(1, Math.round((d - now)/86400000));
    let min=null, max=null;
    if (r.min_delivery_date) min = new Date(r.min_delivery_date);
    if (r.max_delivery_date) max = new Date(r.max_delivery_date);
    if (!min && r.delivery_range?.length===2){ const [a,b]=r.delivery_range; if (a) min=new Date(a); if (b) max=new Date(b); }
    if (!min && r.estimated_delivery_at) min = new Date(r.estimated_delivery_at);
    if (min && !isNaN(min) && max && !isNaN(max)) return `${toDays(min)}–${toDays(max)} days`;
    if (min && !isNaN(min)) return `${toDays(min)} days`;
    const t = getRateTitle(r).toLowerCase();
    if (t.match(/(\d+)\s*[–-]\s*(\d+).*days/)) return t.replace(/.*?(\d+)\s*[–-]\s*(\d+).*days.*/,'$1–$2 days');
    if (t.match(/(\d+).*days/)) return t.replace(/.*?(\d+).*days.*/,'$1 days');
    if (/air|avia|авиа|express|expedited/.test(t)) return '10–12 days';
    if (/sea|ocean|мор|freight|cargo/.test(t))     return '30–35 days';
    return '';
  }
  function formatSelectedShipping(rate){
    if (!rate) return 'Shipping: (not selected)';
    const title = getRateTitle(rate); const transit = extractTransitDays(rate);
    const price = parseFloat(rate.price).toFixed(2); const cur = rate.currency || '';
    return `Shipping: ${title}${transit ? ` (${transit})` : ''} — ${price} ${cur}`;
  }

  function buildCartPropsFromOPC(props = {}, total, rate, addr = {}) {
  // размеры
  const W = props['Width'] || props['Width (mm)'] || props['Ширина'] || props['Bag Width'] || '';
  const H = props['Height'] || props['Height (mm)'] || props['Высота'] || props['Bag Height'] || '';
  const G = props['Gusset'] || props['Gusset (mm)'] || props['Дно/Боковина'] || '';
  const dims = [W && `Width: ${W}`, H && `Height: ${H}`, G && `Gusset: ${G}`].filter(Boolean).join(' | ');

  const units        = props['Number of Units per Design'] || props['Units per Design'] || props['Units'] || '';
  const material     = props['Material'] || '';
  const finishing    = props['Finishing'] || '';
  const customization= props['Customization'] || '';
  const designs      = props['Number of Designs'] || props['Designs count'] || '';

  // доставка
  let shipText = '(not selected)', shipNum = 0;
  if (rate) {
    const title = (rate.presentment_name || rate.name || '').trim();
    const price = parseFloat(rate.price || '0'); shipNum = Number.isFinite(price) ? price : 0;

    const transit = (() => {
      const now = new Date(), toDays = d => Math.max(1, Math.round((d - now)/86400000));
      let min=null, max=null;
      if (rate.min_delivery_date) min = new Date(rate.min_delivery_date);
      if (rate.max_delivery_date) max = new Date(rate.max_delivery_date);
      if (!min && rate.delivery_range?.length===2){ const [a,b]=rate.delivery_range; if (a) min=new Date(a); if (b) max=new Date(b); }
      if (!min && rate.estimated_delivery_at) min = new Date(rate.estimated_delivery_at);
      if (min && !isNaN(min) && max && !isNaN(max)) return `${toDays(min)}–${toDays(max)} days`;
      if (min && !isNaN(min)) return `${toDays(min)} days`;
      const t = title.toLowerCase();
      if (t.match(/(\d+)\s*[–-]\s*(\d+).*days/)) return t.replace(/.*?(\d+)\s*[–-]\s*(\d+).*days.*/,'$1–$2 days');
      if (t.match(/(\d+).*days/)) return t.replace(/.*?(\d+).*days.*/,'$1 days');
      if (/air|avia|авиа|express|expedited/.test(t)) return '10–12 days';
      if (/sea|ocean|мор|freight|cargo/.test(t))     return '30–35 days';
      return '';
    })();

    shipText = `${title}${transit ? ` (${transit})` : ''} — ${shipNum.toFixed(2)} ${rate.currency || ''}`;
  }

  const calcNum    = Number.isFinite(total) ? total : 0;
  const totalQuote = (calcNum + shipNum).toFixed(2);

  // === один пункт = одно свойство; БЕЗ "Order Deposit" ===
  const out = {};
  // Первая строка — “Quote Summary: $<сумма из калькулятора>”
  out['Quote Summary'] = `$${calcNum.toFixed(2)}`;

  // Блок адреса (каждый пункт отдельной строкой)
  if (addr && (addr.country || addr.province || addr.city || addr.zip || addr.address1)) {
    out['Ship to']           = '\u00A0'; // заголовок, чтобы тема не скрыла строку
    if (addr.address1) out['Address']         = addr.address1;
    if (addr.city)     out['City']            = addr.city;
    if (addr.province) out['State / Province']= addr.province;
    if (addr.zip)      out['ZIP / Postal']    = addr.zip;
    if (addr.country)  out['Country']         = addr.country;
  }

  // Остальные строки сводки
  if (dims)       out['Dimensions']        = dims;
  if (units)      out['Units per Design']  = units;
  if (material)   out['Material']          = material;
  if (finishing)  out['Finishing']         = finishing;
  if (customization) out['Customization']  = customization;
  if (designs)    out['Number of Designs'] = designs;

  out['Shipping']    = shipText;
  out['Total Amount'] = `$${totalQuote} (cost from calculator + shipping)`;

  return out;
}



  async function addDepositWithDetails(){
  // 1) собрать данные из UI
  const total = parseMoney((document.querySelector(SELECTOR_TOTAL)?.textContent || '').trim());
  const props = collectOPCMin(10);
  const files = getDesignFiles();
  const rate  = getSelectedRate();
  const addr  = normalizeAddress(); // адрес из попапа

  // 2) сводка OPC
  const W = props['Width'] || props['Width (mm)'] || props['Ширина'] || props['Bag Width'] || '';
  const H = props['Height'] || props['Height (mm)'] || props['Высота'] || props['Bag Height'] || '';
  const G = props['Gusset'] || props['Gusset (mm)'] || props['Дно/Боковина'] || '';
  const dims = [W && `Width: ${W}`, H && `Height: ${H}`, G && `Gusset: ${G}`].filter(Boolean).join(' | ');
  const units  = props['Number of Units per Design'] || props['Units per Design'] || props['Units'] || '';
  const material = props['Material'] || '';
  const finishing = props['Finishing'] || '';
  const customization = props['Customization'] || '';
  const designs = props['Number of Designs'] || props['Designs count'] || '';

  // 3) доставка (текст + число)
  let shipText = '(not selected)', shipNum = 0;
  if (rate) {
    const title   = (rate.presentment_name || rate.name || '').trim();
    const transit = extractTransitDays ? extractTransitDays(rate) : '';
    const p = parseFloat(rate.price || '0'); shipNum = Number.isFinite(p) ? p : 0;
    shipText = `${title}${transit ? ` (${transit})` : ''} — ${shipNum.toFixed(2)} ${rate.currency || ''}`;
  }
  const calcNum = Number.isFinite(total) ? total : 0;
  const totalQuote = `$${(calcNum + shipNum).toFixed(2)} (summary + shipping)`;

  // 4) свойства для корзины
const lineProps = {};

// ❶ Больше НЕ добавляем "Quote Summary"
// // lineProps['Quote Summary'] = `$${calcNum.toFixed(2)}`;

// ❷ Сначала ставим "TOTAL Quote" (итого = калькулятор + доставка)
lineProps['Total Amount'] = `$${(calcNum + shipNum).toFixed(2)} (summary + shipping)`;

// Одинарная строка адреса
const addrParts = [addr.address1, addr.city, addr.province, addr.zip, addr.country].filter(Boolean);
if (addrParts.length) lineProps['Shipping Address'] = addrParts.join(', ');

// Остальные поля
if (dims)        lineProps['Dimensions']        = dims;
if (units)       lineProps['Units per Design']  = units;
if (material)    lineProps['Material']          = material;
if (finishing)   lineProps['Finishing']         = finishing;
if (customization) lineProps['Customization']   = customization;
if (designs)     lineProps['Number of Designs'] = designs;

// ❸ "Shipping" — в самом конце
lineProps['Shipping'] = shipText;

  // 5) атрибуты корзины (адрес дублируем сюда для админки)
  const attrs = {
    quote_source: 'addr-popup',
    quote_total: total ?? '',
    quote_shipping_title: rate ? (rate.presentment_name || rate.name || '').trim() : '',
    quote_shipping_price: rate ? (Number.isFinite(parseFloat(rate.price)) ? parseFloat(rate.price).toFixed(2) : '') : '',
    quote_shipping_currency: rate?.currency || '',
    quote_shipping_transit: rate ? (extractTransitDays ? extractTransitDays(rate) : '') : '',
    quote_files: (files || []).map(f => f.name).join(', '),
    quote_addr_country:  addr?.country  || '',
    quote_addr_province: addr?.province || '',
    quote_addr_city:     addr?.city     || '',
    quote_addr_zip:      addr?.zip      || '',
    quote_addr_address1: addr?.address1 || ''
  };

  // 6) отправка в корзину
  await clearCart();

  if (files && files.length){
    const fd = new FormData();
    fd.append('items[0][id]', DEPOSIT_VARIANT_ID);
    fd.append('items[0][quantity]', '1');
    Object.entries(lineProps).forEach(([k,v]) => fd.append(`items[0][properties][${k}]`, String(v)));
    files.slice(0,5).forEach((file,i)=> fd.append(`items[0][properties][Design #${i+1}]`, file));
    const res = await fetch('/cart/add.js', { method:'POST', credentials:'same-origin', body:fd });
    if (!res.ok) throw new Error('add deposit (multipart) failed: ' + await res.text());
    const up = await fetch('/cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin', body: JSON.stringify({ attributes: attrs })
    });
    if (!up.ok) throw new Error('cart attributes update failed: ' + await up.text());
  } else {
    const res = await fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify({ items:[{ id:DEPOSIT_VARIANT_ID, quantity:1, properties: lineProps }], attributes: attrs })
    });
    if (!res.ok) throw new Error('add deposit failed: ' + await res.text());
  }
}


  function renderRates(list){
    const box = document.getElementById('addr-rates-list');
    const checkoutBtn = document.getElementById('addr-checkout');
    if (!list.length){
      box.innerHTML = '<div class="label-addr-rate">No rates returned.</div>';
      window.__addr_last_rates = []; if (checkoutBtn) checkoutBtn.style.display = 'none'; return;
    }
    window.__addr_last_rates = list.slice();
    box.innerHTML = list.map((r,i)=>{
      const title = getRateTitle(r); const transit = extractTransitDays(r);
      const price = parseFloat(r.price).toFixed(2); const cur = r.currency || '';
      const label = transit ? `${title} <span class="addr-transit">(${transit})</span>` : title;
      return `<label class="label-addr-rate">
        <div style="display:flex;align-items:center;gap:10px;"><input type="radio" name="addr-rate" value="${i}"><div>${label}</div></div>
        <div><strong>${price}</strong> ${cur}</div></label>`;
    }).join('');
    function syncSelection(){
      box.querySelectorAll('.label-addr-rate').forEach(lbl=>{
        const input = lbl.querySelector('input[type="radio"]');
        lbl.classList.toggle('is-selected', input && input.checked);
      });
      const has = !!box.querySelector('input[name="addr-rate"]:checked');
      if (checkoutBtn) checkoutBtn.style.display = has ? '' : 'none';
    }
    box.querySelectorAll('input[name="addr-rate"]').forEach(r => r.addEventListener('change', syncSelection));
    syncSelection();
  }

  async function calculateNow(){
    const checkoutEl = document.getElementById('addr-checkout');
    const calcBtn = document.getElementById('addr-calc');
    if (checkoutEl) checkoutEl.style.display = 'none';
    if (calcBtn) calcBtn.disabled = true;

    clearErrors();

    const status = document.getElementById('addr-status');
    const loader = document.getElementById('addr-spinner');
    const box = document.getElementById('addr-rates-list');
    const addr = normalizeAddress();
    const country = document.getElementById('addr-country')?.value;

    const errs=[];
    const req=(id,msg)=>{ const el=document.getElementById(id); if(!el?.value?.trim()){ setFieldError(id,msg); errs.push(msg);} };
    req('addr-city', country==='United States' ? 'Enter a city' : 'Enter a city/town');
    req('addr-zip',  country==='United States' ? 'Enter a ZIP code' : 'Enter a postal code');

    (function(){
      const sel = document.getElementById('addr-state');
      const inp = document.getElementById('addr-province');
      const useSelect = sel && sel.style.display !== 'none';
      const val = useSelect ? (sel.value||'').trim() : (inp?.value||'').trim();
      if (!val){
        setFieldError(useSelect ? 'addr-state' : 'addr-province',
          country==='United Arab Emirates' ? 'Select an emirate' :
          country==='United States' ? 'Select a state' : 'Select a region');
        errs.push('Select a state / province');
      }
    })();

    if (errs.length){
      showTopError(errs); status.textContent = 'Please fix the highlighted fields.';
      document.querySelector('.addr-invalid')?.focus?.(); if (calcBtn) calcBtn.disabled=false; return;
    }

    box.innerHTML=''; status.textContent='Calculating shipping…'; loader.style.display='inline-block';
    try{
      const rates = await fetchRates(addr);
      renderRates(rates);
      status.textContent = rates.length ? `Found ${rates.length} ${rates.length===1?'shipping option':'shipping options'}` : 'No shipping options available for this address.';
    }catch(e){
      console.error('[rates] failed', e);
      let details=null; const m=String(e?.message||e).match(/\{[\s\S]*\}$/); if(m){ try{ details=JSON.parse(m[0]); }catch{} }
      const msgs=[];
      if(details && typeof details==='object'){
        if(Object.prototype.hasOwnProperty.call(details,'province')){
          const sel = document.getElementById('addr-state'); const useSelect = sel && sel.style.display !== 'none';
          const id = useSelect ? 'addr-state' : 'addr-province';
          const msg = Array.isArray(details.province)?details.province[0]:String(details.province);
          setFieldError(id,msg); msgs.push(msg); delete details.province;
        }
        const map = { zip:'addr-zip', city:'addr-city', country:'addr-country', address1:'addr-address' };
        Object.entries(details).forEach(([k,v])=>{ const id=map[k]; if(!id) return; const msg=Array.isArray(v)?v[0]:String(v); setFieldError(id,msg); msgs.push(msg); });
        showTopError(msgs.length ? msgs : ['Please check your address and try again.']); status.textContent='Please fix the highlighted fields.';
      }else{
        showTopError(['Unexpected error. Please try again.']); status.textContent='Error.';
      }
    }finally{
      loader.style.display='none'; if (calcBtn) calcBtn.disabled=false;
    }
  }

  function getSelectedRate(){
    const v = document.querySelector('input[name="addr-rate"]:checked')?.value;
    const idx = v != null ? Number(v) : -1;
    const list = window.__addr_last_rates || [];
    return (idx >= 0 && idx < list.length) ? list[idx] : null;
  }

  // форматируем "Quote summary" в корзине под UL/LI-разметку темы
function prettifyQuoteSummaryInCart(root = document){
  // спрятать строки "Deposit for custom quote" / "Order Deposit" (если где-то просочились)
  const hideByLabel = (re) => {
    // dt/dd разметка
    root.querySelectorAll('dt, .cart-item__property-name, .cart-property__name, .product-option__name, .name')
      .forEach(lbl => {
        if (!re.test(lbl.textContent || '')) return;
        const row = lbl.closest('li, tr, .cart-item__property, .cart-property, .product-option') || lbl;
        if (row && row.style) row.style.display = 'none';
      });
    // «плоская» разметка
    root.querySelectorAll('li span, .cart-item__property, .product-option__value, .cart-item__property-value, .cart-property__value')
      .forEach(el => {
        const raw = (el.textContent || '').trim();
        const key = (raw.split(':')[0] || '').trim();
        if (!re.test(key)) return;
        const row = el.closest('li') || el;
        if (row && row.style) row.style.display = 'none';
      });
  };
  hideByLabel(/^(order deposit|deposit for custom quote)$/i);

  // больше НИЧЕГО не форматируем — свойства уже приходят по одному пункту.
}




  (function bootQuoteSummaryFormatting(){
    const run = () => prettifyQuoteSummaryInCart(document);
    run();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
    const mo = new MutationObserver(()=>run()); mo.observe(document.body,{childList:true,subtree:true});
  })();

  // ===== hook main button =====
  function attach(){
    ensurePopup();
    const btn = document.querySelector(CALC_BTN_SELECTOR);
    if (!btn || btn.dataset.addrHooked === '1') return;
    btn.addEventListener('click', () => {
      if (CLICK_LOCK) return; CLICK_LOCK = true;
      window.__addr_open();
      document.getElementById('addr-status').textContent = '';
      const calcBtn = document.getElementById('addr-calc');
      if (calcBtn && !calcBtn.dataset.bound){ calcBtn.addEventListener('click', () => calculateNow()); calcBtn.dataset.bound='1'; }
    }, { capture:false });
    btn.dataset.addrHooked = '1';
  }
  new MutationObserver(attach).observe(document.documentElement, { subtree:true, childList:true });
  attach();

  console.info('[addr-popup] slim build ready');
})();
